/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppealConsultation
 */
export interface AppealConsultation {
    /**
     * 
     * @type {number}
     * @memberof AppealConsultation
     */
    estate?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AppealConsultation
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AppealConsultation
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof AppealConsultation
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AppealConsultation
     */
    promoCode?: string;
    /**
     * 
     * @type {string}
     * @memberof AppealConsultation
     */
    question?: string;
    /**
     * 
     * @type {string}
     * @memberof AppealConsultation
     */
    readonly status?: string;
    /**
     * 
     * @type {Date}
     * @memberof AppealConsultation
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AppealConsultation
     */
    readonly updatedAt?: Date;
}

export function AppealConsultationFromJSON(json: any): AppealConsultation {
    return AppealConsultationFromJSONTyped(json, false);
}

export function AppealConsultationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppealConsultation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'estate': !exists(json, 'estate') ? undefined : json['estate'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'promoCode': !exists(json, 'promoCode') ? undefined : json['promoCode'],
        'question': !exists(json, 'question') ? undefined : json['question'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}

export function AppealConsultationToJSON(value?: AppealConsultation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'estate': value.estate,
        'email': value.email,
        'phone': value.phone,
        'name': value.name,
        'promoCode': value.promoCode,
        'question': value.question,
    };
}


